import React from 'react'


const Empty = ({ className, title }) => (
    <div className={`Collapsible__Empty ${className}`}>
        {title}
    </div>
)

export default Empty